import React, { useState } from "react";
import {
    List,
    ListItemButton,
    ListItemIcon,
    Collapse,
    ListItem
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink } from "react-router-dom";
import menuIcons from "../../constants/menuIcons";

// Stil dosyasından özel ListItemText bileşenini içe aktar
import { ListItemText as StyledListItemText } from "../Drawer/style";
import { appColors, primaryAlpha } from "../../constants/theme";

const childNavItemButtonSx = {
    pl: 4,
    borderRadius: "8px",
    width: "100%",
    textDecoration: "none",
    color: "text.primary",
    alignItems: "flex-start",
    whiteSpace: "normal",
    py: 1.25,
    transition: "background-color 0.15s ease, color 0.15s ease",
    "&:hover": {
        backgroundColor: primaryAlpha(0.08),
    },
    "&.active": {
        backgroundColor: primaryAlpha(0.1),
        color: appColors.primary,
        "& .MuiListItemIcon-root": {
            color: appColors.primary,
        },
        "& .MuiListItemText-root .MuiListItemText-secondary": {
            color: appColors.primary,
            fontWeight: 500,
        },
    },
    "& .MuiListItemIcon-root": {
        minWidth: 40,
        marginTop: "2px",
    },
};

const parentNavItemButtonSx = {
    borderRadius: "8px",
    width: "100%",
    alignItems: "flex-start",
    whiteSpace: "normal",
    py: 1.25,
    transition: "background-color 0.15s ease",
    "&:hover": {
        backgroundColor: primaryAlpha(0.08),
    },
    "& .MuiListItemIcon-root": {
        marginTop: "2px",
    },
};

const CollapsibleMenu = ({ item, t, onNavigate }) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => setOpen(!open);

    return (
        <>
            <ListItem disablePadding sx={{ margin: "4px 8px", borderRadius: "8px" }}>
                <ListItemButton onClick={handleClick} sx={parentNavItemButtonSx}>
                    <ListItemIcon sx={{ color: "inherit" }}>
                        {menuIcons[item.icon]}
                    </ListItemIcon>
                    <StyledListItemText secondary={t(item.text)} />
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {item.children.map((child, index) => (
                        <ListItem
                            key={`child-${child.id || child.text}-${index}`}
                            disablePadding
                            sx={{ margin: "4px 8px 4px 32px", borderRadius: "8px" }}
                        >
                            <ListItemButton
                                component={NavLink}
                                to={child.to}
                                onClick={onNavigate}
                                sx={childNavItemButtonSx}
                            >
                                <ListItemIcon sx={{ color: "inherit", minWidth: 40 }}>
                                    {menuIcons[child.icon]}
                                </ListItemIcon>
                                <StyledListItemText secondary={t(child.text)} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </>
    );
};

export default CollapsibleMenu;
